export { FullPageLoader, default } from './fullPageLoader'
export type { FullPageLoaderProps } from './fullPageLoader'
